module.exports = __webpack_public_path__ + "static/mihai-maruseac-8b79f82076754e9206165a889e31af8c.jpg";